import { TrialResult } from "interface/trial"
import { Dialog } from "@mui/material"
import { TrialPreview } from '../../preview'

type TrialPreviewDialogProps = {
  trialList?: TrialResult[]
  trialId?: number | null
	trial?: TrialResult | null
  targetSisetuCode?: string
  targetKojinCode?: string
	onSisetuOpen?: (sisetuCode: string | null) => void
  onKojinOpen?: (kojinCode: string | null) => void
  onClose: () => void
}
export const TrialPreviewDialog = ({
  trialList,
  trialId,
  trial,
  targetSisetuCode,
  targetKojinCode,
  onSisetuOpen,
  onKojinOpen,
  onClose
}: TrialPreviewDialogProps) => {
  return (
    <Dialog
      open
      fullWidth
      maxWidth="lg"
      onClose={() => onClose()}
    >
      <TrialPreview
        trialList={trialList}
        trialId={trialId}
        trial={trial}
        targetSisetuCode={targetSisetuCode}
        targetKojinCode={targetKojinCode}
        onSisetuOpenReply={onSisetuOpen}
        onKojinOpenReply={onKojinOpen}
        onClose={onClose}
        sx={{ height: '90vh' }}
      />
    </Dialog>
  )
}
